import React from 'react'
import { Box } from '@material-ui/core'
import { Link } from 'react-router-dom'

import { useUser } from '../../../hooks/useUser'
import { useLeasingSeasonsList } from '../../LeasingSeason/hooks/useLeasingSeasonQueries'
import { Routes } from '../../../navigation/config/routes'
import { useVoiceAgentStyles } from '../useVoiceAgentStyles'

export const LeasingSeasonNotice: React.FC = () => {
    const classes = useVoiceAgentStyles()
    const { workspaceUser } = useUser()
    const apartmentId = workspaceUser?.active_workspace?.id
    const { data: seasons, isSuccess } = useLeasingSeasonsList(apartmentId)

    const hasCurrentSeason =
        seasons?.some((s) => s.is_current && !s.is_archived) ?? false
    const noCurrentSeason = isSuccess && !hasCurrentSeason

    return (
        <Box className={classes.notice}>
            <span style={{ fontSize: '1rem', lineHeight: 1 }}>&#9432;</span>
            <span>
                {noCurrentSeason ? (
                    <>
                        This property has no current leasing season. Lease term,
                        new and renewal rents, pet policy, and application fee
                        will come from the season once one is set under{' '}
                        <Link
                            to={Routes.manage.leasingSeasonConfig.root}
                            className={classes.noticeLink}
                        >
                            Leasing → Season config
                        </Link>
                        . You can continue without one.
                    </>
                ) : (
                    <>
                        Lease term, new and renewal rents, pet policy, and
                        application fee come from the current leasing season.
                        Edit them under{' '}
                        <Link
                            to={Routes.manage.leasingSeasonConfig.root}
                            className={classes.noticeLink}
                        >
                            Leasing → Season config
                        </Link>
                        . You do not need to re-enter them here or upload them
                        as a reference document.
                    </>
                )}
            </span>
        </Box>
    )
}
